import { render } from "./headerApp.vue?vue&type=template&id=96f0f4fc&scoped=true"
import script from "./headerApp.vue?vue&type=script&lang=js"
export * from "./headerApp.vue?vue&type=script&lang=js"

import "./headerApp.vue?vue&type=style&index=0&id=96f0f4fc&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f0f4fc"]])

export default __exports__